import api from './api';

export interface AnalysisResult {
  status: string;
  data: {
    extracted_text: string;
    full_text_length: number;
    text_by_source?: {
      text: Array<{ content: string; source: string }>;
      documents: Array<{ filename: string; content: string; full_length: number }>;
      audio: Array<{ filename: string; content: string; full_length: number }>;
    };
    suggested_areas: Array<{
      id: string;
      nome: string;
      confidence: number;
      reasoning?: string;
    }>;
    analysis: string;
    files_processed: number;
    audio_files_transcribed?: number;
    credits_used: number;
  };
}

export interface PandoraArea {
  id: string;
  nome: string;
  doc_count: number;
}

export interface Jurisprudence {
  source: string;
  text: string;
  keywords: string[];
  area: string;
  relevance: number;
}

/**
 * Analisa texto e/ou arquivos enviados e sugere áreas do direito
 */
export const analyzeWizardUploads = async (
  text?: string, 
  files?: File[]
): Promise<AnalysisResult> => {
  const formData = new FormData();
  
  if (text) {
    formData.append('text', text);
  }
  
  if (files && files.length > 0) {
    files.forEach(file => {
      formData.append('files', file);
    });
  }

  // Usar fetch diretamente para evitar problemas com FormData
  const token = localStorage.getItem('token');
  const baseURL = import.meta.env.VITE_API_URL || '/api/v1';
  
  const response = await fetch(`${baseURL}/wizard-uploads/analyze`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData
  });
  
  if (!response.ok) {
    throw new Error(`Upload failed: ${response.status}`);
  }
  
  return await response.json();
};

/**
 * Retorna todas as áreas disponíveis do Pandora
 */
export const getWizardAreas = async (): Promise<{ areas: PandoraArea[]; total: number }> => {
  const response = await api.get('/wizard-uploads/areas');
  return response.data.data;
};

/**
 * Retorna jurisprudências para uma área específica
 */
export const getWizardJurisprudences = async (
  area: string,
  limit: number = 20
): Promise<{ jurisprudences: Jurisprudence[]; area: string; total: number }> => {
  const response = await api.get('/wizard-uploads/jurisprudences', {
    params: { area, limit },
  });
  return response.data.data;
};

/**
 * Gera documento a partir dos dados do wizard
 */
export const generateFromWizard = async (wizardData: any): Promise<any> => {
  const response = await api.post('/ai-documents/generate-from-wizard', wizardData);
  return response.data;
};

